import PropTypes from 'prop-types';
import { useMemo } from 'react';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import buildTourFilterOptions from '../../../../../helpers/buildTourFilterOptions';
import useTourFilter from '../../../../../hooks/useTourFilter';

const TourLanguageFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { searchObj, filters, applyFilter } = useTourFilter(tripId);

  const options = useMemo(
    () => buildTourFilterOptions(filters?.languages, searchObj.languages),
    [filters, searchObj.languages],
  );

  if (options.length === 0) {
    return <></>;
  }

  return (
    <CheckboxSelectFilter
      label="Language"
      options={options}
      values={searchObj.languages || []}
      onChange={(languages) => applyFilter({ languages })}
      variant={variant}
      filterSpacingClass={filterSpacingClass}
      filterMaxWidthClass="max-w-full"
      menuWidthClass="w-full md:w-max"
    />
  );
};

TourLanguageFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

TourLanguageFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};

export default TourLanguageFilter;
